import { defineNuxtPlugin } from 'nuxt/app';

export default defineNuxtPlugin((nuxtApp) => {
  if (__AW_IS_DBG_TIMER_ENABLED__) {
    // For how app.config.performance works see:
    // https://vuejs.org/api/application.html#app-config-performance
    nuxtApp.vueApp.config.performance = true;
    /* nuxtApp.vueApp.mixin({
      mounted () {
        const componentName = this.$options.name || this.$options.__name;
        console.log(componentName);
        // onServerPrefetch
        // https://vuejs.org/api/composition-api-lifecycle#onserverprefetch
      },
    }); */
  }
});
